/* unplugin-vue-components disabled */import script from "./shortVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./shortVideo.vue?vue&type=script&setup=true&lang=js"

import "./shortVideo.vue?vue&type=style&index=0&id=7b742c7d&lang=scss"

const __exports__ = script;

export default __exports__